export default "__VITE_ASSET__BBhGkT10__"